import { v4 as uuid } from 'uuid';
import GeneralInfoSkeleton from '../../generalInfo/GeneralInfoSkeleton';

const DescriptionSkeleton = () => {
  const generateTabs = () => {
    const showTabs = Array(3).fill('.');
    return showTabs.map(() => {
      return (
        <div key={uuid()} className={`section`}>
          <div className="fullSkeleton"></div>
        </div>
      );
    });
  };
  return (
    <>
      {' '}
      <div className="containerDescription">
        <div className="principalImg">
          <div className="fullSkeleton" />
        </div>
        <div className="moreImages">
          <div className="containerMoreImg">
            <div className="typeProduct">
              <div className="contanierTitle">
                <div className="text " style={{ width: '80px', padding: '0px' }}>
                  <div className="fullSkeleton"></div>
                </div>
              </div>
              <div className="containerSwitch">
                <div id="customSwitch">
                  <div style={{ width: '80px', height: '24px' }}>
                    <div className="fullSkeleton"></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-3">
              <div className="text-xs" style={{ lineHeight: '14px', color: '#B3B3B3' }}>
                <div className="text-white">Nombre comercial</div>
              </div>
              <div id="customInput">
                <div className="inputSkeleton" />
              </div>
            </div>
            <div className="spaceImages">
              <span id="miniatureUpload">
                <div style={{ width: '80px', height: '80px' }}>
                  <div className="fullSkeleton"></div>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div id="customTabs">
        <div className="containerTabs">{generateTabs()}</div>
      </div>
      <div className="bodyTabs">
        <GeneralInfoSkeleton />
      </div>
    </>
  );
};
export default DescriptionSkeleton;
